import * as Sentry from '@sentry/vue'

/**
 * Reports a problem the user cannot see and would therefore never report.
 *
 * `console.warn` alone dies in whichever browser hit it, which makes it
 * useless for anything configured outside the codebase — a mistyped tour key
 * on an announcement, a feature flag that hides an element something else
 * depends on. Those degrade quietly by design, so Sentry is the only place the
 * mistake ever surfaces.
 *
 * Not for anything the user can act on (show them an error) and not for
 * anything that should crash (let it throw — see the fail-fast rule).
 */
export function reportWarning(
  message: string,
  context?: Record<string, unknown>
): void {
  // Kept for local development, where nothing is wired to Sentry. Spread
  // rather than passed positionally so a context-less call doesn't log a
  // trailing `undefined`.
  console.warn(message, ...(context ? [context] : []))
  Sentry.captureMessage(message, {
    level: 'warning',
    ...(context && { contexts: { detail: context } }),
  })
}
